"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _reactRouterDom = require("react-router-dom");
var _DeleteFlow = _interopRequireDefault(require("./DeleteFlow.js"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Player = _interopRequireDefault(require("../../components/Player"));
var _helpers = require("../../other/helpers.js");
var _EditFlowForm = _interopRequireDefault(require("./EditFlowForm"));
var _eye = _interopRequireDefault(require("cccisd-icons/eye"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Boilerplate = window.cccisd && window.cccisd.boilerplate;
var FlowList = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(FlowList, _React$Component);
  function FlowList() {
    var _this;
    _classCallCheck(this, FlowList);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FlowList, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "_getColumns", function () {
      var $this = _assertThisInitialized(_this);
      return [{
        name: 'id',
        label: 'ID',
        setStyle: function setStyle(value, row) {
          return {
            width: '10px'
          };
        }
      }, {
        name: 'actions',
        label: 'Actions',
        setClass: function setClass() {
          return 'text-center text-nowrap';
        },
        setStyle: function setStyle(value, row) {
          return {
            width: '10px'
          };
        },
        render: function render(value, row, callbacks) {
          return /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_EditFlowForm["default"], {
            editFlow: $this.props.editFlow,
            row: row
          }), ' ', /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
            trigger: /*#__PURE__*/_react["default"].createElement("a", {
              className: "btn btn-success btn-xs",
              title: "Preview",
              id: "preview_flow_button_".concat(row.id)
            }, /*#__PURE__*/_react["default"].createElement(_eye["default"], null)),
            title: "Preview",
            size: "large"
          }, /*#__PURE__*/_react["default"].createElement(_Player["default"], {
            flowId: row.id,
            isPreviewMode: true
          })), ' ', /*#__PURE__*/_react["default"].createElement(_DeleteFlow["default"], {
            flowId: row.id,
            deleteFlow: $this.props.deleteFlow
          }));
        }
      }, {
        name: 'name',
        label: 'Name',
        sort: true,
        filter: true,
        render: function render(value, row) {
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
            to: "/flow/admin/".concat(row.id)
          }, value);
        }
      }, {
        name: 'handle',
        label: 'Handle',
        sort: true,
        filter: true
      }, {
        name: 'type',
        label: 'Type',
        render: function render(value, row, callbacks) {
          var type = (0, _helpers.getFlowTypes)()[value];
          return type ? type.displayName : '';
        }
      }, {
        name: 'url',
        label: 'Url to take the flow',
        render: function render(value, row, callbacks) {
          var url = Boilerplate.url("flow/take/".concat(row.id));
          return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
            to: "/flow/take/".concat(row.id)
          }, url);
        }
      }, {
        name: 'created_at',
        label: 'Created at',
        sort: true
      }];
    });
    return _this;
  }
  _createClass(FlowList, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], {
        data: this.props.data,
        columns: this._getColumns()
      });
    }
  }]);
  return FlowList;
}(_react["default"].Component);
_defineProperty(FlowList, "propTypes", {
  data: _propTypes["default"].array,
  deleteFlow: _propTypes["default"].func,
  editFlow: _propTypes["default"].func
});